var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectBoxLine = function SvgSelectBoxLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.3 3.898h14.4a.9.9 0 0 1 .9.9v14.4a.9.9 0 0 1-.9.9H5.3a.9.9 0 0 1-.9-.9v-14.4a.9.9 0 0 1 .9-.9m.9 1.8v12.6h12.6v-12.6zm5.403 9.9L7.784 11.78l1.273-1.273 2.546 2.546 5.09-5.091 1.274 1.273z"
  })));
};
export default SvgSelectBoxLine;